import { create } from "zustand";
import { persist } from "zustand/middleware";

import genderSupport from "../support_files/genderSupport.json";
import sexualitySupport from "../support_files/sexualitySupport.json";
import raceSupport from "../support_files/raceSupport.json";
import ethnicitySupport from "../support_files/ethnicitySupport.json";
import ethnicityGroupSupport from "../support_files/ethnicityGroupSupport.json";
import ancestrySupport from "../support_files/ancestrySupport.json";
import ancestryGroupSupport from "../support_files/ancestryGroupSupport.json";
import marriageSupport from "../support_files/marriageSupport.json";

import estimatesSupport from "../support_files/estimatesSupport.json";

// ========== IDENTITY PREFERENCES STORE (gender, sexuality, marriage) ==========
export const useOrientationStore = create(
  persist(
    (set) => ({
      gender: genderSupport,
      setGender: (v) => set({ gender: v }),

      sexuality: sexualitySupport,
      setSexuality: (v) => set({ sexuality: v }),

      marriage: marriageSupport,
      setMarriage: (v) => set({ marriage: v }),
    }),
    {
      name: "identity-storage",
    }
  )
);

// ========== AGE PREFERENCES STORE ==========
export const useAgeStore = create(
  persist(
    (set) => ({
      ageRange: [20, 64],
      setAgeRange: (v) => set({ ageRange: v }),
    }),
    {
      name: "age-storage",
    }
  )
);

// ========== HEIGHT PREFERENCES STORE ==========
export const useHeightStore = create(
  persist(
    (set) => ({
      imperial: true,
      setImperial: (v) => set({ imperial: v }),

      height: [58, 75],
      setHeight: (v) => set({ height: v }),

      heightRange: [58, 75],
      setHeightRange: (v) => set({ heightRange: v }),
    }),
    {
      name: "height-storage",
    }
  )
);

// ========== RACE/ETHNICITY/ANCESTRY PREFERENCES STORE ==========
export const useRaceStore = create(
  persist(
    (set) => ({
      activeEthnicityTab: 0,
      setActiveEthnicityTab: (v) => set({ activeEthnicityTab: v }),

      activeRaceTab: 0,
      setActiveRaceTab: (v) => set({ activeRaceTab: v }),

      raceTabSupport: [
        { value: 0, label: "Race", color: "#def3ff" },
        { value: 1, label: "Ethnicity", color: "#abe0ff" },
        { value: 2, label: "Ancestry", color: "#59b7ff" },
      ],

      raceAll: true,
      setRaceAll: (v) => set({ raceAll: v }),

      race: raceSupport,
      setRace: (v) => set({ race: v }),

      ethnicityAll: true,
      setEthnicityAll: (v) => set({ ethnicityAll: v }),

      ethnicity: ethnicitySupport,
      setEthnicity: (v) => set({ ethnicity: v }),

      ethnicityGroup: ethnicityGroupSupport,
      setEthnicityGroup: (v) => set({ ethnicityGroup: v }),

      ancestryAll: true,
      setAncestryAll: (v) => set({ ancestryAll: v }),

      ancestry: ancestrySupport,
      setAncestry: (v) => set({ ancestry: v }),

      ancestryGroup: ancestryGroupSupport,
      setAncestryGroup: (v) => set({ ancestryGroup: v }),
    }),
    {
      name: "race-storage",
    }
  )
);


export const useEstimatesStore = create(
  persist(
    (set) => ({
      estimates: estimatesSupport,
      setEstimates: (v) => set({ estimates: v }),
    }),
    {
      name: "estimates-storage",
    }
  )
);